import FetchErrorContent from './FetchErrorContent';

export default FetchErrorContent;
